/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface QaKpiModel { 
    analyzedCalls?: number;
    avgOperatorScore?: number;
    negativeSentimentPercent?: number;
    escalationPercent?: number;
    flaggedPercent?: number;
}

